import { toAbsoluteUrl } from '@/_metronic/helpers'
import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from './core/Auth'

const SuccessResetPassword: FC = () => {
  const {currentUser, logout} = useAuth()

    const navigate = useNavigate()

    const handleLogout = async () => {
    await logout()
    navigate('/auth') // or whatever your login route is
  }

  return (
    <>
      {/* begin::Title */}
      <h1 className='fw-bolder fs-2hx text-gray-900 mb-4'>Success</h1>
      {/* end::Title */}

      {/* begin::Text */}
      <div className='fw-semibold fs-6 text-gray-500 mb-7'>Change password is success, please login again.</div>
      {/* end::Text */}

      {/* begin::Illustration */}
      <div className='mb-3'>
        <img
          src={toAbsoluteUrl('/media/auth/404-error.png')}
          className='mw-100 mh-300px theme-light-show'
          alt=''
        />
        <img
          src={toAbsoluteUrl('/media/auth/404-error-dark.png')}
          className='mw-100 mh-300px theme-dark-show'
          alt=''
        />
      </div>
      {/* end::Illustration */}

      {/* begin::Link */}
      {/* <div className='mb-0'>
        <button onClick={handleLogout} className='btn btn-sm btn-primary'>
          Return Login
        </button>
      </div> */}
      {/* end::Link */}
    </>
  )
}

export { SuccessResetPassword }

